<div class="wrapper-input">
  <infm-wrapper-input
    [label]="displayedLabel()"
    [icon]="displayedIcon()"
    [isFocus]="isFocus()"
    [isFilled]="isFilled()"
    [isDisabled]="!enable()"
    [errorMessage]="displayedError()"
    [warningMessage]="displayedWarning()"
    [actions]="displayedActions()"
    (clickWrapper)="onClickWrapper()"
    (clickAction)="onClickAction($event)"
  >
    @if (currentValue()) {
      <div class="wrapper-current-value">
        {{ currentValue().join(', ') }}
      </div>
    }
  </infm-wrapper-input>
</div>

@if (enable()) {
  <div class="list-menu">
    <infm-sliding-menu
      [title]="titleSliding() | translate"
      [actions]="actionsSliding()"
      (actionClick)="onActionClickSliding($event)"
    >
      <div
        class="wrapper"
        infSwipe
        (swipeEnd)="onSwipeEnd($event)"
        [ngClass]="{ 'with-search': isSearchActive() }"
      >
        @if (isSearchActive()) {
          <div class="search">
            <infm-input-search (update)="onUpdateSearch($event)" />
          </div>
        }
        <div class="list" #list>
          <infm-list2
            [items]="displayedItems()"
            [isMultiple]="isMultiple()"
            [searchValue]="currentSearch()"
            (itemChange)="onItemChange($event)"
            (clickGroup)="onClickGroup($event)"
          />
        </div>
      </div>
    </infm-sliding-menu>
  </div>
}
